import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';

import SoftBadge from 'components/common/SoftBadge';
import { format } from "date-fns";
import { es } from "date-fns/locale";

import { Col, Spinner } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LinkPago = (
    {
        linkPago,
        setLinksPagos,
        index,
        className,

        GuardarComentario,
    }
) => {

    const { token, setToken, nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [eliminando, setEliminando] = useState(false);
    const [copiado, setCopiado] = useState(false);

    /**
     * Copia el enlace al portapapeles
     */
    const copiarEnlace = async () => {
        try {
            const response = await fetch(`/api/orden/GetPaymentLink?vUUIDLinkPago=${linkPago.vUUIDLinkPago}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
                return null;
            });

            if (response && response.ok) {
                const data = await response.json();
                console.log('Data: ' + data.vMessage);

                if (data.iResponseType === 1) {
                    // Método alternativo para iOS
                    try {
                        await navigator.clipboard.writeText(data.vMessage);
                        setCopiado(true);
                    } catch (clipboardError) {
                        // Fallback para iOS usando un elemento temporal
                        const textArea = document.createElement('textarea');
                        textArea.value = data.vMessage;
                        textArea.style.position = 'fixed';
                        textArea.style.left = '-999999px';
                        textArea.style.top = '-999999px';
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();
                        
                        try {
                            document.execCommand('copy');
                            setCopiado(true);
                        } catch (execError) {
                            console.error('Error al copiar con execCommand:', execError);
                            
                            showErrorToast('No se pudo copiar el enlace. Por favor, cópialo manualmente.');
                        }
                        
                        document.body.removeChild(textArea);
                    }

                    setTimeout(() => {
                        setCopiado(false);
                    }, 2000);
                } else {
                    
                    showErrorToast(data.vMessage);
                }
            } else {
                
                showErrorToast(response?.status + ' ' + response?.statusText);
                console.log(response);

                if (response?.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('Error al copiar al portapapeles:', error);
            
            showErrorToast('Error al obtener el enlace de pago');
        }
    };

    /**
     * Elimina link de pago
     * @param {any} idLinkPago
     */
    const eliminarLinkPago = async (idLinkPago) => {

        setEliminando(true);

        var jDataSend =
        {
            idLinkPago: idLinkPago
        };

        const response = await fetch("/api/orden/stripe_EliminaLinkPago", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        })
            .catch((error) => {
                
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {

            const data = await response.json();
            if (data.iResponseType == 1) {

                // Eliminar el link de la lista actualizada
                setLinksPagos((prevLinks) =>
                    prevLinks.filter((link) => link.idLinkPago !== idLinkPago)
                );

                GuardarComentario("<b>" + nombreCompleto + "</b>  <b class='badge badge-soft-danger'>eliminó </b> el link de pago  <b> # " + idLinkPago + " </b>", 2);


                showSuccessToast(data.vMessage);

            } else {
                showErrorToast(data.vMessage);
            }

            setEliminando(false);
        }
        else {

            setEliminando(false);
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }

    };

    return (

        <>
            {
                linkPago &&
                <>
                    <Col key={index} className={className}>

                        <div key={index} className="mb-3">
                            <div className="d-flex align-items-center">

                                {/* Solo mostrar botón eliminar si NO es link de suscripción (iTipoLink !== 3) */}
                                {linkPago.iTipoLink !== 3 && (
                                    <>
                                        {eliminando ? (
                                            <Spinner className="text-inline me-1" animation="border" size="sm" />
                                        ) : (
                                            <FontAwesomeIcon
                                                icon="trash"
                                                className="fs-1 me-1"
                                                transform="shrink-4"
                                                style={{ color: "#B22222", margin: "5px", cursor: "pointer" }}
                                                onClick={() => eliminarLinkPago(linkPago.idLinkPago)}
                                            />
                                        )}
                                    </>
                                )}

                                <span
                                    className="me-1 text-break text-dark"
                                >
                                    <strong>
                                        {linkPago.idLinkPago} -
                                    </strong>
                                </span>
                                <span
                                    id={`linkPago-${index}`}
                                    className={`me-3 text-break ${linkPago.iStatus !== 0
                                        ? "text-dark"
                                        : copiado
                                            ? "text-secondary"
                                            : "text-primary"
                                        }`}
                                    style={{
                                        cursor: linkPago.iStatus === 0 ? "pointer" : "",
                                        transition: "color 0.2s ease"
                                    }}
                                    onClick={linkPago.iStatus === 0 ? copiarEnlace : undefined}
                                >
                                    <strong>
                                        {copiado
                                            ? "¡Copiado!"
                                            : linkPago.iStatus === 0
                                                ? `Click para copiar enlace de pago por $${parseFloat(
                                                    linkPago.dTotalPago
                                                ).toLocaleString("es-MX", {
                                                    maximumFractionDigits: 2,
                                                    minimumFractionDigits: 2
                                                })} ${linkPago.vMoneda}`
                                                : `Enlace de pago por $${parseFloat(
                                                    linkPago.dTotalPago
                                                ).toLocaleString("es-MX", {
                                                    maximumFractionDigits: 2,
                                                    minimumFractionDigits: 2
                                                })} ${linkPago.vMoneda}`}
                                    </strong>
                                </span>

                            </div>
                            <div className="d-flex align-items-center">
                                <SoftBadge
                                    pill
                                    bg={'primary'}
                                    className="fs--2 me-1"
                                >
                                    <span className="mt-1 mb-1">
                                        Akasia
                                    </span>
                                </SoftBadge>

                                {linkPago.iStatus == 0 ? (
                                    <>
                                        <div className="d-flex align-items-center m-0">
                                            <SoftBadge pill bg="warning" className="fs--2 me-1">
                                                <span className="mt-1 mb-1">No ha sido pagado</span>
                                            </SoftBadge>
                                            <div className="mt-0" style={{ fontSize: "0.7rem" }}>
                                                {format(new Date(linkPago.dCreatedDate), "dd MMMM yyyy", { locale: es })}
                                            </div>
                                        </div>
                                    </>
                                ) : linkPago.iStatus == 1 ? (
                                    <>
                                        <div className="d-flex align-items-center m-0">
                                            <SoftBadge pill bg="success" className="fs--2 me-1">
                                                <span className="mt-1 mb-0">Pagado exitosamente</span>
                                            </SoftBadge>
                                            <div className="mt-0" style={{ fontSize: "0.7rem" }}>
                                                {format(new Date(linkPago.dUpdatedDate), "dd MMMM yyyy", { locale: es })}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="d-flex align-items-center m-0">
                                            <SoftBadge pill bg="danger" className="fs--2 me-1">
                                                <span className="mt-1 mb-0">Error al pagar</span>
                                            </SoftBadge>
                                            <div className="mt-0" style={{ fontSize: "0.7rem" }}>
                                                {format(new Date(linkPago.dUpdatedDate), "dd MMMM yyyy", { locale: es })}
                                            </div>
                                        </div>
                                    </>
                                )}

                            </div>

                        </div>
                    </Col>
                </>
            }
        </>

    );
};

LinkPago.propTypes = {
    linkPago: PropTypes.object,
    setLinksPagos: PropTypes.func,
    index: PropTypes.number,
    className: PropTypes.string,

    GuardarComentario: PropTypes.func,
};

export default LinkPago;